import axios from 'axios'
import { DEFAULT_LOCALE } from '@/constants/languages'

// Deliberately outside the shared $http instance from @/utils/https. That one camelCases every
// response through camelcase-object-deep - `published_at` would arrive as `publishedAt` - and
// carries the 401 refresh queue, the 404 redirect and the 503 maintenance route, none of which
// belong on a public consent route that has no session to recover.
export const consentClient = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  timeout: 15000,
  headers: {
    Accept: 'application/json',
  },
})

// $http sends whatever localStorage holds, including null. These routes are public and the
// backend picks the text revision off this header, so an absent locale has to fall back to a
// real one rather than travel as null.
export function localizationHeader() {
  return {
    'X-localization': localStorage.getItem('app_locale') || DEFAULT_LOCALE,
  }
}
